import { useEffect, useState } from "react";
import api from "@/lib/api";
import DashboardLayout from "@/components/DashboardLayout";
import DocumentUploader from "@/components/DocumentUploader";
import DocumentRow, { PrivacyBadge } from "@/components/DocumentRow";
import { FolderOpen } from "lucide-react";

export default function PortalDocuments() {
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/documents")
      .then((r) => setDocs(r.data))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const onUploaded = (doc) => setDocs((prev) => [doc, ...prev]);
  const onDeleted = (id) => setDocs((prev) => prev.filter((d) => d.id !== id));

  return (
    <DashboardLayout
      role="client"
      title="My Documents"
      subtitle="Your private project file vault — contracts, plans, photos, permits."
    >
      <div className="space-y-6">
        <PrivacyBadge />

        <div className="card p-6">
          <div className="text-xs uppercase tracking-wider mb-3 font-semibold" style={{ color: 'var(--text-muted)' }}>
            Upload a file
          </div>
          <DocumentUploader onUploaded={onUploaded} testid="portal-doc" />
        </div>

        <div className="card p-6">
          <div className="flex items-center justify-between mb-4">
            <div>
              <div className="font-display text-lg font-bold">Your files</div>
              <div className="text-xs mt-0.5" style={{ color: 'var(--text-muted)' }}>
                {docs.length} {docs.length === 1 ? "document" : "documents"}
              </div>
            </div>
          </div>

          {loading ? (
            <div className="text-sm" style={{ color: 'var(--text-muted)' }}>Loading…</div>
          ) : docs.length === 0 ? (
            <div className="p-10 text-center text-sm rounded-lg" style={{ color: 'var(--text-muted)', background: 'rgba(11,19,43,0.4)' }}>
              <FolderOpen className="mx-auto mb-3" />
              No documents yet. Upload a file above, or wait for Coastal Bend to share project files with you.
            </div>
          ) : (
            <div className="space-y-2.5" data-testid="portal-doc-list">
              {docs.map((d) => (
                <DocumentRow key={d.id} doc={d} canDelete onDeleted={onDeleted} />
              ))}
            </div>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
}
